import { HelperResult, LanguageProficiency } from '@openclassrooms/sdk-web';
import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const {
  useFind: useFindLanguageProficiency,
  useUpdate: useUpdateLanguageProficiency,
  useDelete: useDeleteLanguageProficiency,
} = getCRUDHooks({
  entityName: 'languageProficiency',
  update: (
    { level }: { level: string },
    { userId, context, language }: { userId: number; context: string; language: string }
  ): HelperResult<LanguageProficiency[]> =>
    clientApi.getOCClient().helpers.user.users.updateLanguageProficiency(userId, language, level, {
      context,
    }),
  find: ({ userId }: { userId: number }): HelperResult<LanguageProficiency[]> =>
    clientApi.getOCClient().helpers.user.users.id(userId).languageProficiencies.find(),
  remove: ({ userId, languageIso1 }: { userId: number; languageIso1: number }) =>
    clientApi
      .getOCClient()
      .helpers.user.users.id(userId)
      .languageProficiencies.delete(languageIso1),
});

export { useFindLanguageProficiency, useUpdateLanguageProficiency, useDeleteLanguageProficiency };
